export default __webpack_public_path__ + "static/media/peizhen.8cf7983a.jpg";